<template>
  <div>

    <v-navigation-drawer
      v-model="drawer"
      absolute
      temporary
    >

      <v-list-item-content>
        <v-list-item-title class="title px-3 py-1">
         <img v-show="!darkMode" src="/images/logo.png" style="max-width: 125px; height: auto;" />
         <img v-show="darkMode" src="/images/logo-dark.png" style="max-width: 125px; height: auto;" />
         <div class="float-right clickable grey--text" @click.stop="drawer = false">&#10006;</div>
        </v-list-item-title>
      </v-list-item-content>

      <v-divider></v-divider>

      <v-list nav dense flat>

        <v-list-item :to="{name: 'Login'}" link class="nav-draw-link">
          <v-list-item-icon class="drawer-link-icon">
            <v-icon>mdi-login-variant</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('nav.login') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- Help -->
        <v-list-item :to="{name: 'HelpPublic'}" link class="nav-draw-link">
          <v-list-item-icon class="drawer-link-icon">
            <v-icon>mdi-help-circle-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('nav.help') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>


        <v-divider></v-divider>

        <v-list-item class="mt-3">
          <v-list-item-title>
            {{ $t('nav.darkMode') }}:
            <v-icon v-if="darkMode" class="ml-2" large @click="switchDarkMode">mdi-toggle-switch</v-icon>
            <v-icon v-else class="ml-2" large @click="switchDarkMode">mdi-toggle-switch-off-outline</v-icon>
          </v-list-item-title>
        </v-list-item>

        <v-list-item class="mt-1">
          <v-list-item-content>
            <v-list-item-title>{{ $t('common.noun.language') }}:</v-list-item-title>
            <div
            v-for="item in config.i18n"
            :key="item.locale" :value="item.locale"
            @click="setLocale(item.locale)"
            class="ml-4 mt-2">
              <span v-if="item.locale === locale">
                <v-icon>mdi-checkbox-marked</v-icon>
              </span>
              <span v-else>
                <v-icon>mdi-checkbox-blank-outline</v-icon>
              </span>
              {{item.langDisplay}}
            </div>
          </v-list-item-content>
        </v-list-item>


      </v-list>

    </v-navigation-drawer>

    <v-app-bar
      color="black"
      dark
      flat
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <a href="/"><img src="/images/logo-dark.png" style="height: 35px; width: auto; margin-top: 8px" /></a>

      <v-spacer></v-spacer>

      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn small text>
          <router-link class="navbar-link" :to="{name: 'Login'}">{{ $t('nav.login') }}</router-link>
        </v-btn>
      </v-toolbar-items>

      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn small text>
          <router-link class="navbar-link" :to="{name: 'HelpPublic'}">{{ $t('nav.help') }}</router-link>
        </v-btn>
      </v-toolbar-items>

      <!-- Settings -->
      <v-menu offset-y bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>mdi-settings</v-icon>
          </v-btn>
        </template>
        <v-list dense nav>
          <v-list-item dense>
            <v-list-item-title>
              {{ $t('nav.darkMode') }}:
              <v-icon v-if="darkMode" class="ml-2" large @click="switchDarkMode">mdi-toggle-switch</v-icon>
              <v-icon v-else class="ml-2" large @click="switchDarkMode">mdi-toggle-switch-off-outline</v-icon>
            </v-list-item-title>
          </v-list-item>

          <v-list-item dense>
            <v-list-item-content style="max-width: 120px;">
              <v-list-item-title>{{ $t('common.noun.language') }}:</v-list-item-title>
              <div
              v-for="item in config.i18n"
              :key="item.locale" :value="item.locale"
              @click="setLocale(item.locale)"
              class="ml-3 mt-1">
                <span v-if="item.locale === locale">
                  <v-icon>mdi-checkbox-marked</v-icon>
                </span>
                <span v-else>
                  <v-icon>mdi-checkbox-blank-outline</v-icon>
                </span>
                <small class="ml-2">{{item.langDisplay}}</small>
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>

    </v-app-bar>
  </div>
</template>

<script>
import { config } from '@/config'
export default {
  data () {
    return {
      config: config,
      drawer: false,
      darkMode: false,
      locale: null,
      langDisplay: '',
    }
  },
  computed: {
    isMobile: function () {
      return this.$vuetify.breakpoint.xsOnly
    }
  },
  methods: {
    checkDarkMode () {
      const localConfig = localStorage.getItem(config.localStorageKey.darkMode)
      if (localConfig && localConfig === 'Y') {
        this.darkMode = true
        this.turnOnDarkMode()
      }
      else {
        this.darkMode = false
      }
    },

    turnOnDarkMode () {
      this.$vuetify.theme.dark = true
      localStorage.setItem(config.localStorageKey.darkMode, 'Y');
      this.darkMode = true
    },

    turnOffDarkMode () {
      this.$vuetify.theme.dark = false
      localStorage.removeItem(config.localStorageKey.darkMode)
      this.darkMode = false
    },

    switchDarkMode () {
      // console.log('switchDarkMode')
      if (this.darkMode === true) {
        this.turnOffDarkMode()
      }
      else {
        this.turnOnDarkMode()
      }
    },

    getLocale () {
      const localStored = localStorage.getItem(config.localStorageKey.locale)
      if (localStored) {
        return localStored
      }
      else {
        let systemLange = navigator.language || navigator.browserLanguage || navigator.userLanguage
        if (systemLange) {
          systemLange = systemLange.toLowerCase()
          const lang = config.i18n.find(
          item =>
            item.locale === systemLange ||
            item.aliases.some(alias => alias === systemLange)
          )
          if (lang) {
            return lang.locale
          }
          else {
            return this.config.defaultLocale
          }
        }
        else {
          return this.config.defaultLocale
        }
      }
    },
    setLocale(locale) {
      locale = locale.toLowerCase()
      localStorage.setItem(config.localStorageKey.locale, locale)
      this.$i18n.locale = locale
      this.locale = locale
      this.langDisplay = this.getLangDisplay()
    },
    getLangDisplay: function () {
      let val = ''
      for (let item of config.i18n) {
        if (item.locale === this.locale) {
          val = item.langDisplay
          return val
        }
      }
      return val
    },


  },
  created () {
    this.checkDarkMode()
    this.locale = this.getLocale()
    this.$i18n.locale = this.locale
    this.langDisplay = this.getLangDisplay()
  },
}
</script>

<style scoped>
.drawer-link-icon {
  margin-right: 10px !important;
}
.navbar-link {
  color: #CCC !important;
  text-decoration: none;
  font-size: 14px;
}
.nav-draw-link {
  /*color: #444 !important;*/
}
.testnet-name {
  padding: 10px;
  background-color: #e5f376;
  color: #424242;
  border-radius: 3px;
}
</style>
